import {Dictionary} from '@malt/types-utils';

const ARG_REGEXP = /{.*?}/g;

export function buildUrl(urlTpl: string, ...ids: any[]): string {
    const args = Array.isArray(ids) ? [...ids] : [ids];
    return urlTpl.replace(ARG_REGEXP, () => args.shift());
}

export function extractIdsFromUrl(urlTpl: string, url: string): string[] {
    const urlTplParts = urlTpl.split('/').slice(1);
    const urlParts = url.split('/').slice(1);

    const idIdxs: number[] = urlTplParts.reduce((acc: number[], el: string, i: number) => {
        return el.match(ARG_REGEXP) ? [...acc, i] : acc;
    }, []);

    return urlParts.filter((el: string, idx: number) => {
        return idIdxs.includes(idx);
    });
}

export function mapIdsFromUrl(urlTpl: string, url: string): Dictionary<string> {
    const urlTplParts = urlTpl.split('/').slice(1);
    const urlParts = url.split('/').slice(1);

    return urlTplParts.reduce(
        (acc, el: any, index: number): any => (el.match(ARG_REGEXP) && urlParts[index] ? {...acc, [el.slice(1, -1)]: urlParts[index]} : acc),
        {} as any,
    );
}

export function parseUrlParams(params: string): URLSearchParams {
    return new URLSearchParams(params ? params.substring(1) : '');
}
